module.exports = __webpack_public_path__ + "static/media/alliance-for-energy-innovation-fy26-logo-black.de147ed6.svg";